var Tree = /** @class */ (function () {
    function Tree(value) {
        if (value === void 0) { value = null; }
        this.childs = [];
        this.value = null;
        this.parent = null;
        if (value) {
            if (Array.isArray(value)) {
                this.value = value[0];
                if (value.length > 1) {
                    this.addChild(new Tree(value.slice(1)));
                }
            }
            else if (value instanceof Tree) {
                this.value = value.value;
                this.childs = value.childs;
            }
            else {
                this.value = value;
            }
        }
    }
    Tree.prototype.contains = function (value) {
        if (this.value === value)
            return true;
        for (var _i = 0, _a = this.childs; _i < _a.length; _i++) {
            var child = _a[_i];
            if (child.contains(value))
                return true;
        }
        return false;
    };
    Tree.prototype.findNode = function (value) {
        if (this.value === value)
            return this;
        for (var _i = 0, _a = this.childs; _i < _a.length; _i++) {
            var child = _a[_i];
            var result = child.findNode(value);
            if (result)
                return result;
        }
        return null;
    };
    Tree.prototype.addChild = function (child) {
        child.parent = this;
        this.childs.push(child);
    };
    Tree.prototype.setParents = function () {
        for (var _i = 0, _a = this.childs; _i < _a.length; _i++) {
            var child = _a[_i];
            child.parent = this;
            child.setParents();
        }
    };
    return Tree;
}());
export { Tree };
//# sourceMappingURL=tree.js.map